<template>
  <div class="header-wrapper animate fadeIn">
    <div class="container">
      <h1 class="header-title">กองผ้าป่าของฉัน</h1>
      <div class="row" v-if="pages.length > 0">
        <div class="col col-lg-4 col-md-6 col-sm-6" v-for="page in pages" :key="page.id">
          <router-link :to="pageLink(page)"><img class="preview-image" :src="page.image" alt="sample" /></router-link>
          <div class="title"><router-link :to="pageLink(page)">{{ page.title }}</router-link></div>
        </div>
      </div>
      <div class="row" v-if="pages.length === 0 && loaded">
        <div class="col-md-3">
        </div>
        <div class="col-md-6 text-center mb-20">
          <p>คุณยังไม่มีกองผ้าป่า</p>
          <router-link :to="linkCreate()" class="w-50 ma-auto btn btn--purple" v-if="mainProductSku">สร้างกองผ้าป่า</router-link>
        </div>
        <div class="col-md-3">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Loader from './Loader'

  export default {
    name: 'MyPagePage',

    components: {
      Loader
    },

    data () {
      return {
        pages: [],
        loading: false,
        loaded: false,
        error: false,
        mainProductSku: ''
      }
    },

    created () {
      this.mainProductSku = process.env.MAIN_PRODUCT_SKU
      this.getPages()
    },

    methods: {
      getPages () {
        this.loading = true
        const params = {
          member_id: this.$store.state.user.uuid
        }
        this.$http.get('pages', { params: params })
          .then(resp => {
            this.pages = resp.body.pages || []
            this.loading = false
            this.loaded = true
          })
          .catch(err => {
            console.log(err)
            this.error = true
            this.loading = false
            this.loaded = true
          })
      },

      linkCreate () {
        return `/${this.mainProductSku}/pages/create`
      },

      pageLink (page) {
        if (page.code.startsWith('blank')) {
          return `/pages/${page.id}`
        }
        return `/${page.code}`
      }
    }
  }
</script>

<style lang="scss" scoped>
.row {
  .col {
    margin-bottom: 50px;
    .title {
      font-weight: 400;
      font-size: 1.2em;
      line-height: 1.5em;
    }
    .preview-image {
      max-width: 100%;
      height: 200px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// MyPagePage.vue?0883a91a